import React from "react";
import { Colors, useTheme } from "@zapier/design-system";
import { getHostedFieldId } from "../utils";
import SensitiveData from "@zapier/payment/esm/components/SensitiveData";
import { HostedFieldType, HostedFieldValue } from "@zapier/payment/esm/types";

type Props = {
  /** Show error styling */
  hasError: boolean;
  /** Call when field changes value */
  onChange: (value: HostedFieldValue) => void;
  /** Field type to show */
  type: HostedFieldType;
};

const Styles = {
  container: (props: Props) =>
    ({
      alignItems: "center",
      background: props.hasError ? Colors.lava20 : Colors.gray10,
      borderRadius: 10,
      border: `2px solid ${props.hasError ? Colors.error : Colors.gray10}`,
      boxSizing: "content-box",
      display: "flex",
      height: 19,
      overflow: "hidden",
      padding: 10,
      "> *": {
        flex: "0 0 100%",
      },
    } as const),
};

/* Rebrand cleanup required */
const rebrandStyles = {
  container: (props: Props) =>
    ({
      background: "none",
      borderRadius: 3,
      height: 24,
      padding: "9px 15px",
      border: `1px solid ${
        props.hasError ? Colors.error500 : Colors.neutral600
      }`,
    } as const),
};

const HostedField: React.FC<Props> = props => {
  const { isRebrand } = useTheme();
  return (
    <div
      css={[
        Styles.container(props),
        isRebrand && rebrandStyles.container(props),
      ]}
    >
      <SensitiveData>
        <div id={getHostedFieldId(props.type)} />
      </SensitiveData>
    </div>
  );
};

export default HostedField;
